<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Division Edit</CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                label="Divisi"
                class="mb-0"
                type="text"
                required
                horizontal
                placeholder="Division"
                v-model="data.division_name"
                @change="handleDivisionName"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                label="Status"
                :options="optionsStatus"
                required
                horizontal
                v-model="data.status"
                @change="handleStatus"
              />
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton color="success" class="float-right" @click="updateDivision">Save</CButton>
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import jwt from "jsonwebtoken";
import DivisionUseCase from "../app/usecase/division";

export default {
  name: "DivisionEdit",
  data() {
    return {
      data: {},
      dataOld: {},
      token: "Bearer " + localStorage.getItem("token"),
      optionsStatus: ["ACTIVE", "INACTIVE"],
    };
  },
  mounted() {
    this.authentication()
    this.getDetail()
  },
  methods: {
    handleStatus(event) {
      this.data.status = event.target.value;
    },
    handleDivisionName(event) {
      this.data.division_name = event;
    },
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "HRD" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null
      } else {
        this.$router.push({ path: `/` });
      }
    },
    goBack() {
      if (JSON.stringify(this.data) !== JSON.stringify(this.dataOld)) {
        return this.$swal.fire({
          icon: "info",
          title: "Are you sure want to leave?",
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          showCancelButton: true,
          showCloseButton: true
        }).then((result) => {
          if (result.isConfirmed) {
            this.usersOpened ? this.$router.go(-1) : this.$router.push({ path: "/career/division" });
          }
        })
      } else {
        this.usersOpened ? this.$router.go(-1) : this.$router.push({ path: "/career/division" });
      }
    },
    async getDetail() {
      const { data, err } = await DivisionUseCase.getOne(this.$route.params.id)
      if (data) {
        this.data = data.data
        this.dataOld = { ...this.data }
      }
      if (err) {
        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: err,
        })
        this.$router.push({ path: `/career/division` });
      }
    },
    async updateDivision() {
      const formData = new FormData()
      formData.append("division_name", this.data.division_name);
      formData.append("status", this.data.status);
      const { err } = await DivisionUseCase.editOne(this.$route.params.id, formData)
      if (err) {
        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: err
        })
      }
      else {
        this.$swal.fire({
          icon: "success",
          title: `Division Updated`,
          showConfirmButton: false,
          timer: 2000,
        })
        this.$router.push({ path: `/career/division` });
      }
    }
  }
}
</script>
